// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tomes_container {
  width: 100%;
  min-height: 100vh;
  background-color: #151018;
  position: relative;
}
.tomes_container .tomes_header {
  width: 100%;
  padding: 2rem 1.5rem 0.2rem 1.5rem;
  display: flex;
}
.tomes_container .tomes_header .tomes_logo {
  width: 15%;
  display: flex;
  align-items: center;
  position: relative;
}
.tomes_container .tomes_header .tomes_logo .org {
  display: block;
  position: absolute;
  color: #e8e5e5;
  font-size: 0.8rem;
  top: -1rem;
  left: 40%;
  transform: translateX(-35%);
}
.tomes_container .tomes_header .tomes_logo img {
  width: 30%;
  margin-left: 30%;
  cursor: pointer;
}
.tomes_container .tomes_header .tomes_logo .back {
  position: absolute;
  right: 0.4rem;
  top: 50%;
  transform: translateY(-50%);
  width: 46.34px;
  height: 46.34px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  color: #FFFFFF;
  background-color: #231B27;
  border: 1px solid #231B27;
  border-radius: 0.4rem;
}
.tomes_container .tomes_header .tomes_logo .back:hover {
  background-color: #2a202e;
  color: rgb(214, 65, 10);
}
.tomes_container .tomes_header .tomes_search {
  width: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tomes_container .tomes_header .tomes_search .input {
  width: 100%;
  height: 46.34px;
  padding: 0.48rem 1rem;
  outline: none;
  background-color: #231B27;
  border-radius: 0.6rem;
  border: 1px solid #231B27;
  color: #898989;
  font-size: 1.2rem;
}
.tomes_container .tomes_header .tomes_search .input::placeholder {
  color: #898989;
}
.tomes_container .tomes_header .tomes_avatar {
  width: 15%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  padding-left: 0.5rem;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}
.tomes_container .tomes_header .tomes_avatar .avatar {
  width: 3.313rem;
  height: 3.313rem;
  background-color: #bababa;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  transition: 0.1s linear;
}
.tomes_container .tomes_header .tomes_avatar .avatar:hover {
  background-color: #e8e5e5;
  color: rgb(214, 65, 10);
  font-size: 1.5rem;
}
.tomes_container .tomes_header .tomes_avatar .notif {
  width: 3.313rem;
  height: 3.313rem;
  background-color: #231B27;
  color: #e8e5e5;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  position: relative;
  transition: 0.1s linear;
}
.tomes_container .tomes_header .tomes_avatar .notif:hover {
  color: #D91D6F;
  font-size: 1.5rem;
}
.tomes_container .tomes_header .tomes_avatar .notif .num_of_notifs {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  background-color: #bd2969;
  position: absolute;
  top: -0.3rem;
  left: 80%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  color: black;
}
.tomes_container .tomes_header .tomes_avatar .sub_list {
  width: 80%;
  margin: 0 auto;
  padding: 1rem 0.2rem;
  background-color: #231B27;
  position: absolute;
  bottom: -6.5rem;
  border-radius: 0.6rem;
  z-index: 10;
}
.tomes_container .tomes_header .tomes_avatar .sub_list .item {
  display: block;
  margin: 0.4rem 1rem;
  text-decoration: none;
  color: #FFFFFF;
}
.tomes_container .tomes_header .tomes_avatar .sub_list .item:hover {
  color: rgb(214, 65, 10);
}
.tomes_container .tomes_header .tomes_avatar .notif_list {
  width: 120%;
  height: 50vh;
  margin: 0 auto;
  padding: 1rem 0.6rem;
  background-color: #231B27;
  position: absolute;
  bottom: -50vh;
  left: -40%;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 0.6rem;
  z-index: 10;
}
.tomes_container .tomes_header .tomes_avatar .notif_list .nofit_item {
  display: block;
  width: 100%;
  font-size: 0.6rem;
  color: #e8e5e5;
  padding: 0.8rem 0.6rem;
  background-color: #bd2969;
}
.tomes_container .tomes_content {
  width: 70%;
  margin: 0 auto;
  padding: 0 1rem;
}
.tomes_container .tomes_content h2 {
  color: #FFFFFF;
  margin: 3rem 0;
  font-size: 2rem;
}
.tomes_container .tomes_content .tomes_cards {
  width: 100%;
  padding: 1.5rem 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 2rem;
}
.tomes_container .tomes_content .tomes_cards .add_tome_card {
  width: 17rem;
  height: 25rem;
  border: 1px solid #FFFFFF;
  border-radius: 1.25rem;
  cursor: pointer;
}
.tomes_container .tomes_content .tomes_cards .add_tome_card .add_tome_icon {
  width: 17rem;
  height: 15rem;
  color: #FFFFFF;
  justify-content: center;
  align-items: center;
  font-size: 12rem;
  display: flex;
  transition: 0.2s linear;
}
.tomes_container .tomes_content .tomes_cards .add_tome_card .add_tome_icon:hover {
  color: rgb(214, 65, 10);
}
.tomes_container .tomes_content .tomes_cards .add_tome_card .add_tome_text {
  width: 17rem;
  height: 8rem;
  padding: 1rem;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
}
.tomes_container .tomes_content .tomes_cards .tome_card {
  width: 17rem;
  height: 25rem;
  border: 1px solid #FFFFFF;
  border-radius: 1.25rem;
  background-color: rgb(255, 199, 96);
  color: rgb(203, 57, 4);
  font-size: 1.5rem;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  animation: onCreateCard 0.5s forwards ease-in;
}
.tomes_container .tomes_content .tomes_cards .tome_card a {
  display: flex;
  width: 17rem;
  height: 25rem;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  text-align: center;
  color: rgb(203, 57, 4);
}
.tomes_container .tomes_content .tomes_cards .tome_card .flag {
  display: flex;
  width: 2rem;
  height: 1.3rem;
  position: absolute;
  top: 0.6rem;
  right: 0.8rem;
}
.tomes_container .tomes_content .tomes_cards .tome_card .isLayered {
  display: flex;
  width: 2rem;
  height: 1.3rem;
  position: absolute;
  top: 0.6rem;
  left: 0.8rem;
  color: rgb(63, 63, 63);
}
.tomes_container .tomes_content .tomes_cards .tome_card .tome_card_details {
  width: 17rem;
  height: 10rem;
  padding-top: 0.5rem;
  background: rgba(46, 44, 52, 0.737254902);
  position: absolute;
  bottom: -12rem;
  transition: 0.2s linear;
}
.tomes_container .tomes_content .tomes_cards .tome_card .tome_card_details .row {
  color: #FFFFFF;
  font-size: 1rem;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.tomes_container .tomes_content .tomes_cards .tome_card .tome_card_details .row .edit {
  font-size: 1.1rem;
  cursor: pointer;
}
.tomes_container .tomes_content .tomes_cards .tome_card .tome_card_details .row .edit:hover {
  color: #cacaca;
}
.tomes_container .tomes_content .tomes_cards .tome_card:hover .tome_card_details {
  bottom: 0;
}
.tomes_container .add_tome_modale {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  background: rgba(26, 23, 28, 0.5411764706);
}
.tomes_container .add_tome_modale .add_tome_modale_content {
  width: 55.1875rem;
  height: 27.875rem;
  background-color: #231B27;
  padding: 2rem;
  border-radius: 0.8rem;
  font-size: 80%;
}
.tomes_container .add_tome_modale .add_tome_modale_content h2 {
  color: #e8e5e5;
  font-size: 1.4rem;
}
.tomes_container .add_tome_modale .add_tome_modale_content .options {
  display: flex;
  font-size: 1rem;
  font-weight: 500;
  gap: 3rem;
  margin-top: 2rem;
}
.tomes_container .add_tome_modale .add_tome_modale_content .options li {
  list-style: none;
  color: #e8e5e5;
  border-bottom: 1px solid #e8e5e5;
  cursor: pointer;
}
.tomes_container .add_tome_modale .add_tome_modale_content .details_option {
  margin-top: 2rem;
  line-height: 3;
  color: #e8e5e5;
  font-size: 0.85rem;
  font-weight: 600;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.tomes_container .add_tome_modale .add_tome_modale_content .details_option .left {
  width: 50%;
}
.tomes_container .add_tome_modale .add_tome_modale_content .details_option .right {
  width: 50%;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form {
  width: 100%;
  height: 18rem;
  display: flex;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_left {
  width: 50%;
  height: 20rem;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_left .input_block {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  margin: 1.8rem 0;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_left .input_block label {
  color: rgba(255, 255, 255, 0.6980392157);
  font-size: 1.1rem;
  font-weight: 400;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_left .input_block input,
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_left .input_block select {
  width: 95%;
  padding: 0.6rem;
  outline: none;
  border: 2px solid rgba(255, 255, 255, 0.6980392157);
  color: rgba(255, 255, 255, 0.6980392157);
  background-color: #231B27;
  border-radius: 0.4rem;
  font-size: 1rem;
  font-weight: 600;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_left .input_block input::placeholder,
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_left .input_block select::placeholder {
  color: rgba(255, 255, 255, 0.6980392157);
  font-size: 1.1rem;
  font-weight: 500;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_left .input_block .pdf_size {
  font-size: 0.8rem;
  color: #bababa;
  font-weight: 500;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_left .input_block .upload {
  cursor: pointer;
  padding-left: 2.5rem;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_left .input_block .pdf_file {
  display: none;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_left .input_block #file_pdf_block {
  position: relative;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_left .input_block #file_pdf_block .upload_icon {
  position: absolute;
  left: 0.8rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.6980392157);
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_right {
  width: 50%;
  height: 20rem;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_right .input_block {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  margin: 1.8rem 0;
  margin-left: 5%;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_right .input_block label {
  color: rgba(255, 255, 255, 0.6980392157);
  font-size: 1.1rem;
  font-weight: 400;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_right .input_block input, .tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_right .input_block select {
  width: 95%;
  padding: 0.6rem;
  outline: none;
  border: 2px solid rgba(255, 255, 255, 0.6980392157);
  color: rgba(255, 255, 255, 0.6980392157);
  background-color: #231B27;
  border-radius: 0.4rem;
  font-size: 1rem;
  font-weight: 600;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_right .input_block input::placeholder, .tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form .add_tome_form_right .input_block select::placeholder {
  color: rgba(255, 255, 255, 0.6980392157);
  font-size: 1.1rem;
  font-weight: 500;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form_btns {
  padding: 0.5rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.5rem;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form_btns button {
  width: 8rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  font-size: 1rem;
  font-weight: 600;
  background-color: rgba(56, 47, 61, 0.6509803922);
  color: rgba(255, 255, 255, 0.6980392157);
  outline: none;
  border: 1px solid rgba(255, 255, 255, 0.6980392157);
  border-radius: 0.5rem;
  cursor: pointer;
  transition: 0.2s linear;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form_btns button:hover {
  background-color: #775DA6;
  color: rgba(255, 255, 255, 0.6980392157);
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form_btns .add_tome_loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.1rem;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form_btns .add_tome_loading .creating {
  display: flex;
  font-size: 1.8rem;
  color: #a5a3a3;
  animation: sending 0.8s linear infinite;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form_btns .add_tome_loading .creating_tome {
  font-weight: 400;
  color: #bababa;
  font-size: 1.3rem;
  text-shadow: 2px 2px 2px rgb(0, 0, 0);
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form_btns #cree {
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
  color: rgba(255, 255, 255, 0.6980392157);
  border: none;
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form_btns #cree:hover {
  background: linear-gradient(180deg, #D91D6F 0%, #c41762 100%);
  color: rgba(255, 255, 255, 0.6980392157);
}
.tomes_container .add_tome_modale .add_tome_modale_content .add_tome_form_btns #cree .creating {
  display: flex;
  animation: sending 0.8s linear infinite;
}

@keyframes onCreateCard {
  from {
    transform: translateY(0.8rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes sending {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/tome/_Tome.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AACJ;AACI;EACI,WAAA;EACA,kCAAA;EACA,aAAA;AACR;AACQ;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AACZ;AAEY;EACI,cAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;AAAhB;AAGY;EACI,UAAA;EACA,gBAAA;EACA,eAAA;AADhB;AAIY;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAFhB;AAIgB;EACI,yBAAA;EACA,uBAAA;AAFpB;AAOQ;EACI,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AALZ;AAOY;EACI,WAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;AALhB;AAOgB;EACI,cAAA;AALpB;AAUQ;EACI,UAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AARZ;AAUY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AARhB;AAUgB;EACI,yBAAA;EACA,uBAAA;EACA,iBAAA;AARpB;AAYY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AAVhB;AAYgB;EACI,cAAA;EAEA,iBAAA;AAXpB;AAcgB;EACI,aAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AAZpB;AAgBY;EACI,UAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EAEA,qBAAA;EACA,WAAA;AAfhB;AAiBgB;EACI,cAAA;EAEA,mBAAA;EACA,qBAAA;EACA,cAAA;AAhBpB;AAkBoB;EACI,uBAAA;AAhBxB;AAqBY;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EAEA,qBAAA;EACA,WAAA;AApBhB;AAsBgB;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;AApBpB;AA0BI;EACI,UAAA;EACA,cAAA;EACA,eAAA;AAxBR;AA0BQ;EACI,cAAA;EACA,cAAA;EACA,eAAA;AAxBZ;AA2BQ;EACI,WAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,2BAAA;EACA,SAAA;AAzBZ;AA2BY;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;AAzBhB;AA2BgB;EACI,YAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAzBpB;AA2BoB;EACI,uBAAA;AAzBxB;AA8BgB;EACI,YAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA5BpB;AAgCY;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,mCAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;AA9BhB;AAgCgB;EACI,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;AA9BpB;AAiCgB;EACI,aAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AA/BpB;AAmCgB;EACI,aAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAjCpB;AAqCgB;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;AAnCpB;AAqCoB;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;AAnCxB;AAqCwB;EACI,iBAAA;EACA,eAAA;AAnC5B;AAqC4B;EACI,cAAA;AAnChC;AAyCgB;EACI,SAAA;AAvCpB;AA6CI;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,0CAAA;AA3CR;AA8CQ;EACI,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,cAAA;AA5CZ;AA8CY;EACI,cAAA;EACA,iBAAA;AA5ChB;AA+CY;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AA7ChB;AA+CgB;EACI,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,eAAA;AA7CpB;AAiDY;EACI,gBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,8BAAA;AA/ChB;AAiDgB;EACI,UAAA;AA/CpB;AAkDgB;EACI,UAAA;AAhDpB;AAsDY;EACI,WAAA;EACA,aAAA;EACA,aAAA;AApDhB;AAsDgB;EACI,UAAA;EACA,aAAA;AApDpB;AAsDoB;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AApDxB;AAsDwB;EACI,wCAAA;EACA,iBAAA;EACA,gBAAA;AApD5B;AAuDwB;;EAEI,UAAA;EACA,eAAA;EACA,aAAA;EACA,mDAAA;EACA,wCAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AArD5B;AAuD4B;;EACI,wCAAA;EACA,iBAAA;EACA,gBAAA;AApDhC;AAwDwB;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;AAtD5B;AAyDwB;EACI,eAAA;EACA,oBAAA;AAvD5B;AA0DwB;EACI,aAAA;AAxD5B;AA2DwB;EACI,kBAAA;AAzD5B;AA2D4B;EACI,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,iBAAA;EACA,wCAAA;AAzDhC;AAgEgB;EACI,UAAA;EACA,aAAA;AA9DpB;AAgEoB;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AA9DxB;AAgEwB;EACI,wCAAA;EACA,iBAAA;EACA,gBAAA;AA9D5B;AAiEwB;EACI,UAAA;EACA,eAAA;EACA,aAAA;EACA,mDAAA;EACA,wCAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AA/D5B;AAiE4B;EACI,wCAAA;EACA,iBAAA;EACA,gBAAA;AA/DhC;AAsEY;EACI,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AApEhB;AAsEgB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gDAAA;EACA,wCAAA;EACA,aAAA;EACA,mDAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;AApEpB;AAsEoB;EACI,yBAAA;EACA,wCAAA;AApExB;AAyEgB;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAvEpB;AAyEoB;EACI,aAAA;EACA,iBAAA;EACA,cAAA;EACA,uCAAA;AAvExB;AA2EoB;EACI,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,qCAAA;AAzExB;AA6EgB;EACI,6DAAA;EACA,wCAAA;EACA,YAAA;AA3EpB;AA6EoB;EACI,6DAAA;EACA,wCAAA;AA3ExB;AA8EoB;EACI,aAAA;EACA,uCAAA;AA5ExB;;AAoFA;EACI;IACI,6BAAA;IACA,UAAA;EAjFN;EAoFE;IACI,wBAAA;IACA,UAAA;EAlFN;AACF;AAqFA;EACI;IACI,uBAAA;EAnFN;EAoFI;IACE,yBAAA;EAlFN;AACF","sourcesContent":[".tomes_container {\n    width: 100%;\n    min-height: 100vh;\n    background-color: #151018;\n    position: relative;\n\n    .tomes_header {\n        width: 100%;\n        padding: 2rem 1.5rem .2rem 1.5rem;\n        display: flex;\n\n        .tomes_logo {\n            width: 15%;\n            display: flex;\n            align-items: center;\n            position: relative;\n            // border: 1px solid green;\n\n            .org{\n                display: block;\n                position: absolute;\n                color: #e8e5e5;\n                font-size: .8rem;\n                top: -1rem;\n                left: 40%;\n                transform: translateX(-35%);\n            }\n\n            img{\n                width: 30%;\n                margin-left: 30%;\n                cursor: pointer;\n            }\n\n            .back {\n                position: absolute;\n                right: .4rem;\n                top: 50%;\n                transform: translateY(-50%);\n                width: 46.34px;\n                height: 46.34px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.4rem;\n                color: #FFFFFF;\n                background-color: #231B27;\n                border: 1px solid #231B27;\n                border-radius: .4rem;\n\n                &:hover {\n                    background-color: #2a202e;\n                    color: rgb(214, 65, 10);\n                }\n            }\n        }\n\n        .tomes_search {\n            width: 70%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            .input {\n                width: 100%;\n                height: 46.34px;\n                padding: .48rem 1rem;\n                outline: none;\n                background-color: #231B27;\n                border-radius: .6rem;\n                border: 1px solid #231B27;\n                color: #898989;\n                font-size: 1.2rem;\n\n                &::placeholder {\n                    color: #898989;\n                }\n            }\n        }\n\n        .tomes_avatar {\n            width: 15%;\n            display: flex;\n            justify-content: flex-start;\n            align-items: center;\n            gap: 1rem;\n            padding-left: .5rem;\n            position: relative;\n            user-select: none;\n\n            .avatar {\n                width: 3.313rem;\n                height: 3.313rem;\n                background-color: #bababa;\n                border-radius: 50%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.3rem;\n                font-weight: 700;\n                cursor: pointer;\n                transition: .1s linear;\n\n                &:hover {\n                    background-color: #e8e5e5;\n                    color: rgb(214, 65, 10);\n                    font-size: 1.5rem;\n                }\n            }\n\n            .notif {\n                width: 3.313rem;\n                height: 3.313rem;\n                background-color: #231B27;\n                color: #e8e5e5;\n                border-radius: 50%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.3rem;\n                font-weight: 700;\n                cursor: pointer;\n                position: relative;\n                transition: .1s linear;\n\n                &:hover {\n                    color: #D91D6F;\n                    // color: rgb(214, 65, 10);\n                    font-size: 1.5rem;\n                }\n\n                .num_of_notifs{\n                    width: 1.2rem;\n                    height: 1.2rem;\n                    border-radius: 50%;\n                    background-color: #bd2969;\n                    position: absolute;\n                    top: -.3rem;\n                    left: 80%;\n                    transform: translateX(-50%);\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    font-size: .8rem;\n                    color: black;\n                }\n            }\n\n            .sub_list {\n                width: 80%;\n                margin: 0 auto;\n                padding: 1rem .2rem;\n                background-color: #231B27;\n                position: absolute;\n                bottom: -6.5rem;\n                // bottom: 0;\n                border-radius: .6rem;\n                z-index: 10;\n\n                .item {\n                    display: block;\n                    // text-align: center;\n                    margin: .4rem 1rem;\n                    text-decoration: none;\n                    color: #FFFFFF;\n\n                    &:hover {\n                        color: rgb(214, 65, 10);\n                    }\n                }\n            }\n\n            .notif_list {\n                width: 120%;\n                height: 50vh;\n                margin: 0 auto;\n                padding: 1rem .6rem;\n                background-color: #231B27;\n                position: absolute;\n                bottom: -50vh;\n                left: -40%;\n                display: flex;\n                flex-direction: column;\n                gap: .2rem;\n                overflow-x: hidden;\n                overflow-y: auto;\n                // bottom: 0;\n                border-radius: .6rem;\n                z-index: 10;\n\n                .nofit_item{\n                    display: block;\n                    width: 100%;\n                    font-size:.6rem ;\n                    color: #e8e5e5;\n                    padding: .8rem .6rem;\n                    background-color: #bd2969;\n                }\n            }\n        }\n    }\n\n    .tomes_content {\n        width: 70%;\n        margin: 0 auto;\n        padding: 0 1rem;\n\n        h2 {\n            color: #FFFFFF;\n            margin: 3rem 0;\n            font-size: 2rem;\n        }\n\n        .tomes_cards {\n            width: 100%;\n            padding: 1.5rem 1rem;\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: flex-start;\n            gap: 2rem;\n\n            .add_tome_card {\n                width: 17rem;\n                height: 25rem;\n                border: 1px solid #FFFFFF;\n                border-radius: 1.25rem;\n                cursor: pointer;\n\n                .add_tome_icon {\n                    width: 17rem;\n                    height: 15rem;\n                    color: #FFFFFF;\n                    justify-content: center;\n                    align-items: center;\n                    font-size: 12rem;\n                    display: flex;\n                    transition: .2s linear;\n\n                    &:hover {\n                        color: rgb(214, 65, 10);\n                        ;\n                    }\n                }\n\n                .add_tome_text {\n                    width: 17rem;\n                    height: 8rem;\n                    padding: 1rem;\n                    color: #FFFFFF;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    font-weight: 400;\n                }\n            }\n\n            .tome_card {\n                width: 17rem;\n                height: 25rem;\n                border: 1px solid #FFFFFF;\n                border-radius: 1.25rem;\n                background-color: rgb(255, 199, 96);\n                color: rgb(203, 57, 4);\n                font-size: 1.5rem;\n                font-weight: 700;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                overflow: hidden;\n                position: relative;\n                animation: onCreateCard .5s forwards ease-in;\n\n                a {\n                    display: flex;\n                    width: 17rem;\n                    height: 25rem;\n                    justify-content: center;\n                    align-items: center;\n                    text-decoration: none;\n                    text-align: center;\n                    color: rgb(203, 57, 4);\n                }\n\n                .flag{\n                    display: flex;\n                    width: 2rem;\n                    height: 1.3rem;\n                    position: absolute;\n                    top: .6rem;\n                    right: .8rem;\n                    // border: 1px solid red;\n                }\n\n                .isLayered{\n                    display: flex;\n                    width: 2rem;\n                    height: 1.3rem;\n                    position: absolute;\n                    top: .6rem;\n                    left: .8rem;\n                    color: rgb(63, 63, 63);\n                    // border: 1px solid red;\n                }\n\n                .tome_card_details {\n                    width: 17rem;\n                    height: 10rem;\n                    padding-top: .5rem;\n                    background: #2e2c34bc;\n                    position: absolute;\n                    bottom: -12rem;\n                    transition: .2s linear;\n\n                    .row {\n                        color: #FFFFFF;\n                        font-size: 1rem;\n                        font-weight: 400;\n                        display: flex;\n                        justify-content: space-between;\n                        padding: 0.5rem 1rem;\n\n                        .edit {\n                            font-size: 1.1rem;\n                            cursor: pointer;\n\n                            &:hover {\n                                color: #cacaca;\n                            }\n                        }\n                    }\n                }\n\n                &:hover .tome_card_details {\n                    bottom: 0;\n                }\n            }\n        }\n    }\n\n    .add_tome_modale {\n        width: 100%;\n        height: 100vh;\n        position: fixed;\n        top: 0;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 1rem;\n        background: #1a171c8a;\n        // display: none;\n\n        .add_tome_modale_content {\n            width: 55.1875rem;\n            height: 27.875rem;\n            background-color: #231B27;\n            padding: 2rem;\n            border-radius: .8rem;\n            font-size: 80%;\n\n            h2 {\n                color: #e8e5e5;\n                font-size: 1.4rem;\n            }\n\n            .options{\n                display: flex;\n                font-size: 1rem;\n                font-weight: 500;\n                gap: 3rem;\n                margin-top: 2rem;\n                \n                li{\n                    list-style: none;\n                    color: #e8e5e5;\n                    border-bottom: 1px solid #e8e5e5;\n                    cursor: pointer;\n                }\n            }\n\n            .details_option{\n                margin-top: 2rem;\n                line-height: 3;\n                color: #e8e5e5;\n                font-size: .85rem;\n                font-weight: 600;\n                display: flex;\n                width: 100%;\n                justify-content: space-between;\n\n                .left{\n                    width: 50%;\n                    // border: 1px solid red;\n                }\n                .right{\n                    width: 50%;\n                    // border: 1px solid red;\n                }\n            }\n\n\n            .add_tome_form {\n                width: 100%;\n                height: 18rem;\n                display: flex;\n\n                .add_tome_form_left {\n                    width: 50%;\n                    height: 20rem;\n\n                    .input_block {\n                        display: flex;\n                        flex-direction: column;\n                        gap: .1rem;\n                        margin: 1.8rem 0;\n\n                        label {\n                            color: #FFFFFFB2;\n                            font-size: 1.1rem;\n                            font-weight: 400;\n                        }\n\n                        input,\n                        select {\n                            width: 95%;\n                            padding: .6rem;\n                            outline: none;\n                            border: 2px solid #FFFFFFB2;\n                            color: #FFFFFFB2;\n                            background-color: #231B27;\n                            border-radius: .4rem;\n                            font-size: 1rem;\n                            font-weight: 600;\n\n                            &::placeholder {\n                                color: #FFFFFFB2;\n                                font-size: 1.1rem;\n                                font-weight: 500;\n                            }\n                        }\n\n                        .pdf_size{\n                            font-size: .8rem;\n                            color: #bababa;\n                            font-weight: 500;\n                        }\n\n                        .upload {\n                            cursor: pointer;\n                            padding-left: 2.5rem;\n                        }\n\n                        .pdf_file {\n                            display: none;\n                        }\n\n                        #file_pdf_block {\n                            position: relative;\n\n                            .upload_icon {\n                                position: absolute;\n                                left: .8rem;\n                                top: 50%;\n                                transform: translateY(-50%);\n                                font-size: 1.2rem;\n                                color: #FFFFFFB2;\n                            }\n                        }\n\n                    }\n                }\n\n                .add_tome_form_right {\n                    width: 50%;\n                    height: 20rem;\n\n                    .input_block {\n                        width: 100%;\n                        display: flex;\n                        flex-direction: column;\n                        gap: .1rem;\n                        margin: 1.8rem 0;\n                        margin-left: 5%;\n\n                        label {\n                            color: #FFFFFFB2;\n                            font-size: 1.1rem;\n                            font-weight: 400;\n                        }\n\n                        input, select {\n                            width: 95%;\n                            padding: .6rem;\n                            outline: none;\n                            border: 2px solid #FFFFFFB2;\n                            color: #FFFFFFB2;\n                            background-color: #231B27;\n                            border-radius: .4rem;\n                            font-size: 1rem;\n                            font-weight: 600;\n\n                            &::placeholder {\n                                color: #FFFFFFB2;\n                                font-size: 1.1rem;\n                                font-weight: 500;\n                            }\n                        }\n                    }\n                }\n            }\n\n            .add_tome_form_btns {\n                padding: .5rem 0;\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                margin-top: 1.5rem;\n\n                button {\n                    width: 8rem;\n                    height: 3rem;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    gap: 1rem;\n                    font-size: 1rem;\n                    font-weight: 600;\n                    background-color: #382F3DA6;\n                    color: #FFFFFFB2;\n                    outline: none;\n                    border: 1px solid #FFFFFFB2;\n                    border-radius: .5rem;\n                    cursor: pointer;\n                    transition: .2s linear;\n\n                    &:hover {\n                        background-color: #775DA6;\n                        color: #FFFFFFB2;\n                    }\n\n                }\n\n                .add_tome_loading{\n                    display: flex;\n                    flex-direction: column;\n                    justify-content: center;\n                    align-items: center;\n                    gap: .1rem;\n\n                    .creating{\n                        display: flex;\n                        font-size: 1.8rem;\n                        color: #a5a3a3;\n                        animation: sending .8s linear infinite;\n                        \n                    }\n\n                    .creating_tome{\n                        font-weight: 400;\n                        color: #bababa;\n                        font-size: 1.3rem;\n                        text-shadow: 2px 2px 2px rgb(0, 0, 0);\n                    }\n                }\n\n                #cree {\n                    background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                    color: #FFFFFFB2;\n                    border: none;\n\n                    &:hover {\n                        background: linear-gradient(180deg, #D91D6F 0%, #c41762 100%);\n                        color: #FFFFFFB2;\n                    }\n\n                    .creating{\n                        display: flex;\n                        animation: sending .8s linear infinite;\n                    }\n                }\n            }\n        }\n    }\n}\n\n@keyframes onCreateCard {\n    from {\n        transform: translateY(.8rem);\n        opacity: 0;\n    }\n\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n@keyframes sending {\n    from {\n        transform: rotate(0deg);\n    } to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
